/** @format */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-undef */

import React, { createContext, useContext, useReducer } from 'react';

/**
 * State Context.
 */
export const StateContext = createContext();

/**
 * State Provider.
 *
 * @param {*} param0
 */
export const StateProvider = ({ children }): JSX.Element => {
  const initialState = {
    menuItem: { active: null, previous: null, parent: null },
    menuTransitioning: { transitioning: false, direction: null },
    openToggle: { menuOpen: false, closing: false },
    updateToggle: { localeOpen: false },
    swipeToggle: { currentlySwiping: false },
    contactToggle: { contactFormOpen: false },
    urlFormCheck: { contactFormCheck: false },
  };

  /**
   * Context Reducer.
   *
   * @param {*} state
   * @param {*} action
   */
  const reducer = (state, action) => {
    switch (action.type) {
      case 'updateActive':
        return {
          ...state,
          menuItem: action.makeActive,
        };

      case 'navigating':
        return {
          ...state,
          menuTransitioning: action.setTransition,
        };

      case 'toggleMenu':
        return {
          ...state,
          openToggle: action.toggleOpen,
        };

      case 'toggleLocale':
        return {
          ...state,
          updateToggle: action.updateLocale,
        };

      case 'swipingMenu':
        return {
          ...state,
          swipeToggle: action.setSwipe,
        };

      case 'toggleContactForm':
        return {
          ...state,
          contactToggle: action.formToggle,
        };

      case 'urlFormInitializeCheck':
        return {
          ...state,
          urlFormCheck: action.setUrlContactFormCheck,
        };

      default:
        return state;
    }
  };

  return (
    <StateContext.Provider value={useReducer(reducer, initialState)}>
      {children}
    </StateContext.Provider>
  );
};

/**
 * Use State Value.
 */
export const useStateValue = () => useContext(StateContext);
